import React from 'react';
import { Alert, Box, Button, Container, Stack, Typography } from '@mui/material';
import { reportWebError } from 'src/utils/errorTelemetry';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    this.lastError = error;
    reportWebError(error, {
      source: 'react_render',
      context: { componentStack: info?.componentStack || null }
    });
    console.error('[ui] uncaught render error', error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <Box minHeight="100vh" display="flex" alignItems="center" bgcolor="background.default">
        <Container maxWidth="sm">
          <Stack spacing={2}>
            <Typography variant="h3">AutoClever could not display this screen</Typography>
            <Alert severity="error">
              Your data was not changed. Reload the application to restore the current view.
            </Alert>
            <Button variant="contained" onClick={() => window.location.reload()}>
              Reload AutoClever
            </Button>
          </Stack>
        </Container>
      </Box>
    );
  }
}

export default AppErrorBoundary;
